/**
 * Returns true when a config node is enabled.
 * Supports boolean nodes or objects with optional `enable` flag.
 */
export const isConfigEnabled = (config, defaultValue = true) => {
    if (config == null) {
        return defaultValue;
    }

    if (typeof config === 'boolean') {
        return config;
    }

    if (typeof config.enable === 'boolean') {
        return config.enable;
    }

    return defaultValue;
};
